module.exports = __webpack_public_path__ + "static/media/Login_background.472e45b0.jpg";